<template>
  <div class="radio-group-container noselect">
    <div
      class="item noselect shadow"
      v-for="option in options"
      :key="option.title"
      @click="
        select(option);
        $emit('input', option);
      "
      :class="`${selected.title == option.title ? 'selected' : ''} ${
        rounded ? 'circles' : ''
      }`"
    >
      <img
        v-if="option.img"
        :src="api.GET_IMAGE(option.img)"
        :alt="options.title"
      />
      <span>{{ option.title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "RadioGroup",
  props: {
    options: {
      type: Array,
      required: true,
    },
    rounded: {
      type: Boolean,
    },
    value: {
      required: true,
    },
    error: {
      type: Boolean,
      required: false,
    },
    errorMessage: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      selected: "",
    };
  },
  methods: {
    select(val) {
      if (this.selected != val) this.selected = val;
    },
  },
  watch: {
    value: {
      handler: function (val) {
        this.selected = val;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.shadow {
  box-shadow: 0 0 6px rgb(0 11 138 / 12%) !important;
}
.radio-group-container {
  width: 100%;
  height: max-content;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  row-gap: 10px;
  float: left;

  .selected {
    box-shadow: inset 0 0 0 1px #e10015 !important;
    opacity: 1 !important;
    span {
      color: red !important;
    }
  }

  .circles {
    min-width: 38px;
    max-height: 38px;
  }

  .noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
            supported by Chrome, Edge, Opera and Firefox */
  }

  .item {
    float: left;
    width: max-content;
    padding: 12px 15px;
    background-color: white;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 3px;
    cursor: pointer;
    border-radius: 9999px;
    opacity: 0.7;

    img {
      height: auto;
      width: auto;
      max-height: 18px;
    }

    span {
      font-size: 14px;
      text-align: left;
      color: #2f434c;
    }
  }
}
</style>
